module.exports = __webpack_public_path__ + "img/connect-1-m.697610ac.png";